import { HugeiconsIcon } from '@hugeicons/react';
import { ShieldUserIcon } from '@hugeicons/core-free-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@components/Button/Button';
import { backofficePath } from '@lib/backofficeRoutes';

/** Full-page access denied state for unauthorized admin routes. */
export function AdminAccessDeniedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="mx-auto flex w-full max-w-xl flex-col items-center rounded-card border border-surface-border bg-surface-cards p-8 text-center sm:p-10">
        <span className="mb-5 inline-flex h-16 w-16 items-center justify-center rounded-full bg-surface-primary-lighter text-primary">
          <HugeiconsIcon icon={ShieldUserIcon} size={32} />
        </span>
        <h1 className="mb-2 text-xl font-bold text-primary sm:text-2xl">
          {t('admin.permissionDenied.pageTitle', { defaultValue: 'Access denied' })}
        </h1>
        <p className="mb-8 text-sm text-primary/70 sm:text-base">
          {t('admin.permissionDenied.pageMessage', {
            defaultValue: 'عذراً، لا تملك صلاحية الوصول لهذه الصفحة',
          })}
        </p>
        <Button
          type="button"
          variant="primary"
          size="lg"
          onClick={() => navigate(backofficePath(''))}
        >
          {t('admin.permissionDenied.backToDashboard', { defaultValue: 'Back to dashboard' })}
        </Button>
      </div>
    </section>
  );
}
